"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getParentId = void 0;
var getParentId = function (el, root) {
    var _a, _b;
    if (!el || !el.parentElement) {
        return;
    }
    do {
        el = el.parentElement;
    } while (el && !(((_a = el.dataset) === null || _a === void 0 ? void 0 : _a.viewid) || el.isSameNode(root)));
    return el && ((_b = el.dataset) === null || _b === void 0 ? void 0 : _b.viewid);
};
exports.getParentId = getParentId;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0UGFyZW50SWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZ2V0UGFyZW50SWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRU8sSUFBTSxXQUFXLEdBQUcsVUFBQyxFQUFzQixFQUFFLElBQWlCOztJQUNuRSxJQUFJLENBQUMsRUFBRSxJQUFJLENBQUMsRUFBRSxDQUFDLGFBQWEsRUFBRTtRQUM1QixPQUFPO0tBQ1I7SUFDRCxHQUFHO1FBQ0QsRUFBRSxHQUFHLEVBQUUsQ0FBQyxhQUFhLENBQUM7S0FDdkIsUUFBUSxFQUFFLElBQUksQ0FBQyxDQUFDLENBQUEsTUFBQSxFQUFFLENBQUMsT0FBTywwQ0FBRSxNQUFNLEtBQUksRUFBRSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFO0lBRTdELE9BQU8sRUFBRSxLQUFJLE1BQUEsRUFBRSxDQUFDLE9BQU8sMENBQUUsTUFBTSxDQUFBLENBQUM7QUFDbEMsQ0FBQyxDQUFDO0FBVFcsUUFBQSxXQUFXLGVBU3RCIn0=